module.exports = __webpack_public_path__ + "img/insta-cover.0f121c0a.jpg";